import { render, staticRenderFns } from "./Messages.vue?vue&type=template&id=4f9d1bb5&"
import script from "./Messages.vue?vue&type=script&lang=js&"
export * from "./Messages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f9d1bb5')) {
      api.createRecord('4f9d1bb5', component.options)
    } else {
      api.reload('4f9d1bb5', component.options)
    }
    module.hot.accept("./Messages.vue?vue&type=template&id=4f9d1bb5&", function () {
      api.rerender('4f9d1bb5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shared/components/Messages.vue"
export default component.exports